<template>
    <div>
        <HeaderSection />
        <!--<CheapFlights />-->
        <HowItWorks />
        <AboutUs />
        <ContactUs />
        <FooterSection />
    </div>
</template>

<script>
/* eslint-disable */

import FooterSection from '../../../components/FooterSection'
import CheapFlights from './CheapFlights'
import AboutUs from './AboutUs'
import ContactUs from './ContactUs'
import HowItWorks from './HowItWorks'
import HeaderSection from './HeaderSection'

export default {
    name: 'HomePage',
    components: {
        HeaderSection,
        FooterSection,
        CheapFlights,
        AboutUs,
        ContactUs,
        HowItWorks,
    },
}
</script>



// WEBPACK FOOTER //
// src/pages/index/components/HomePage.vue